const RECORDING_TEST_PHRASE = 'Hello! My name is Julia.'

export default RECORDING_TEST_PHRASE
